
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M15 23a8 8 0 100-16 8 8 0 000 16z","stroke":"#F2994A"}}),_c('path',{attrs:{"d":"M19 11.667l-5.667 6.666L11 16","stroke":"#F2994A","stroke-linecap":"round"}})])
          )
        }
      }
    